import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import Button from '@/views/button';
import CollectionTableView from '@/views/collection_table';
import SentInvite from '@/views/sent_invite';
import PendingInvite from '@/views/pending_invite';
import AlertMixin from '@/mixins/alert';
import ProxyView from '@/views/proxy';
import template from '@/../templates/invites-layout.hbs';
import CollaboratorItemView from '@/views/collaborator_item';

var empty_tmpl = '<p class="primary">This Account has no pending Collaborator Invitations.</p>'
            + '<p>To add collaborators click on Add a collaborator button.</p>';

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');

var EmptyPendingView = Marionette.View.extend({
    template: Handlebars.compile(empty_tmpl)
});
function empty_list_view_options(collection) {
    return {
        className: 'no-products',
        collection: collection,
        template: Handlebars.compile(empty_tmpl),
    };
}
function create_pending_list_view(collection) {
    return new Marionette.CollectionView({
        collection: collection,
        childView: SentInvite,
        className: 'row',
        emptyView: EmptyPendingView,
        emptyViewOptions: empty_list_view_options(collection)
    });
}

function create_roles_invites_view(received_invites) {
    var primary = globalCh.request('primary_account');
    var proxies = primary.proxies;

    return new Marionette.CollectionView({
        collection: received_invites,
        childView: PendingInvite,
        className: 'row',
        emptyView: EmptyPendingView,
        emptyViewOptions: empty_list_view_options(received_invites),
        model: proxies
    });
}

function create_memberships_list_view(collection) {
    var active_account = globalCh.request('active_account');
    return new CollectionTableView({
        collection: collection,
        childView: CollaboratorItemView,
        childViewOptions: {
            targetAccount: active_account
        },
        class_name: 'collaborator-list',
        default_sort_column: 1,
        columns: [
            {
                name: '',
                class_name: 'current-user'
            },
            {
                name: 'Username / Email',
                class_name: 'username',
                sort_by: 'name'
            },
            {
                name: 'Status',
                class_name: 'state',
                sort_by: 'state'
            },
            {
                name: 'Roles',
                class_name: 'role',
            },
            {
                name: 'Manage'
            }
        ]
    });
}

function create_roles_accepted_view(collection) {
    var active_account = globalCh.request('active_account');
    return new CollectionTableView({
        collection: collection,
        childView: ProxyView,
        childViewOptions: {
            active_account: active_account
        },
        class_name: 'collaborator-list',
        default_sort_column: 1,
        columns: [
            {
                name: '',
                class_name: 'current-user'
            },
            {
                name: 'Account',
                class_name: 'name',
                sort_by: 'username'
            },
            {
                name: 'Role',
                class_name: 'role',
            },
            {
                name: 'Manage'
            }
        ]
    });   
}


var CollaboratorsLayout =  Marionette.View.extend(AlertMixin).extend({
    className: 'standard-layout',
    ui: {
        tabs: '.nav-tabs',
        create_item: '.create-item-region',
        alerts: '.alerts',
        pending: '.pending-region',
        memberships: '.memberships-region',
        roles_invites: '.roles-invites-region',
        roles_accepted: '.roles-accepted-region'
    },
    regions: {
        create_item: '@ui.create_item',
        alerts: '@ui.alerts',
        pending: '@ui.pending',
        memberships: '@ui.memberships',
        roles_invites: '@ui.roles_invites',
        roles_accepted: '@ui.roles_accepted'
    },
    events: {},
    initialize: function() {
        globalCh.reply('layout_alert', this.alert.bind(this));
    },
    templateContext: function() {
        return {
            title: this.getOption('title') || 'Untitled',
            invites_title: this.getOption('invites_title'),
            grants_title: this.getOption('grants_title'),
            invites_received_title: this.getOption('invites_received_title'),
            roles_accepted_title: this.getOption('roles_accepted_title'),
            
            // In the case we are not wanting to show the
            // controls region, ie, no pagination, no buttons
            // in the group div. If no_controls evaluates to
            // true, the controls region will have a class
            // added to it.
            no_controls: this.getOption('no_controls') || false
        };
    },
    template: Handlebars.compile(template),
    collectionEvents: {
        'update': 'on_collection_update'
    },
    childViewEvents: {
        'alert': 'child_alert',
    },
    onRender: function() {
        var primary = globalCh.request('primary_account');
        var new_proxies = primary.new_proxies;
        var pending_view = create_pending_list_view(this.options.sent_invites);
        this.showChildView('pending', pending_view);
        var memberships_view = create_memberships_list_view(this.options.memberships);
        this.showChildView('memberships', memberships_view);
        var roles_invites_view = create_roles_invites_view(this.options.received_invites);
        this.showChildView('roles_invites', roles_invites_view);
        var roles_accepted_view = create_roles_accepted_view(new_proxies);
        this.showChildView('roles_accepted', roles_accepted_view);
        
        this.showChildView('create_item', new Button({
            className: 'btn btn-primary',
            text: 'Add a collaborator',
            icon: 'fa fa-plus-circle',
            action: _.bind(this.show_add_dialog, this)
        }));

        this.ui.tabs.tab();
    },
    child_alert: function(message, type, timeout) {
        this.alert(message, type, timeout);
    },
    show_add_dialog: function() {
        var self = this;
        var invites = apiCh.request('invite');
        var options = {
            success: function(model, sent_values) {
                var email = sent_values.email;
                var message = 'Successfully sent invitation to ' + email;
                invites.fetch();
                self.alert(message, 'success', 5000);
            }
        };
        globalCh.request('show_add_collaborator_dialog', this.model, options);
    },
});
export default CollaboratorsLayout;

